/*
 * @Author: Teemo Ding
 * @Date: 2021-12-07 14:41:44
 * @LastEditTime: 2022-04-27 15:53:32
 * @LastEditors: Teemo Ding
 * @FilePath: /unifyxp-v2-store-portal/src/pages/Order/Components/VoucherItem/index.tsx
 */
import { EShipping } from '@/src/types/common/discount';
import { cloneDeep } from 'lodash';
import React from 'react';
import { OriCheckbox } from 'src/components/Antd';
import { useI18n } from 'src/hooks/useRouterChange';
import { EMethod } from 'src/pages/StoreVoucher/Detail/VoucherType';
import { i18nGet, replaceI18nVariables } from 'src/tools/tools';
import css from './css.module.less';

const VoucherItem = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const { value, onChange, vouchers, disable, currency, scTimezoneUTC } = props;
  const voucherText = {
    [EMethod.Percentage]: ` ${getI18n('allOrders.orderDetail.oFF')}`,
    [EMethod.Reduction]: `- ${currency} `,
    [EMethod.Shipping]: {
      [EShipping.Free]: getI18n('allOrders.orderDetail.freeShipping'),
      [EShipping.Fixed]: `${getI18n(
        'allOrders.orderDetail.shippingFee',
      )} - ${currency} `,
    },
    [EMethod.Gift]: getI18n(
      'allOrders.orderDetail.orderInfo_columns_PaidPrice_judgegift',
    ),
    [EMethod.GiftPurchase]: getI18n(
      'allOrders.orderDetail.orderInfo_columns_PaidPrice_judgegift',
    ),
  };

  const handleCheck = (e, item, index) => {
    const vouchersUuids = cloneDeep(value || []);
    if (e.target.checked) {
      (vouchersUuids || []).push(item.customerVoucherUuid); //item.customerVoucherUuid
      if (onChange) onChange(vouchersUuids);
    } else {
      const vouchersUuidsFilter = vouchersUuids.filter(
        (o) => o !== item.customerVoucherUuid,
      );
      if (onChange) onChange(vouchersUuidsFilter);
    }
  };
  return (vouchers || []).map((item, index) => (
    <div key={index} className={css.voucherItemContain}>
      <OriCheckbox
        disabled={disable}
        onChange={(e) => handleCheck(e, item, index)}
        checked={(value || []).includes(item.customerVoucherUuid)} //item.customerVoucherUuid
        className={css.voucherItemCheck}
      />
      <div className={css.voucherItem}>
        <div className={css.description}>
          <p>{item.description}</p>
          <span className={css.subDescription}>
            {replaceI18nVariables(
              getI18n(
                'allOrders.createneworder.component_discountselection_valid',
              ),
              item.beginDate,
              item.endDate,
              scTimezoneUTC,
            )}
          </span>
        </div>
        <div className={css.price}>
          {/* {item.} */}
          {item.shippingDiscountType
            ? `${item.percentage ? item.percentage + '%' : ''}${
                voucherText[item.voucherType][item.shippingDiscountType]
              }`
            : `${item.percentage ? item.percentage + '%' : ''}${
                voucherText[item.voucherType]
              }`}
          {item.voucherPrice}
        </div>
      </div>
    </div>
  ));
};

export default VoucherItem;
